<template>
  <div id="cards-game" class="game">
    <router-link to="/" tag="div" class="close">×</router-link>
    <h1>Cards</h1>
    <form class="game-wrapper layout-1">
      <div class="layout-content">
        <div id="card" v-if="n >= 0" :data-card="deck[n]"></div>
      </div>
      <div class="layout-navigation">
        <button class="action-button reset-button" @click="reset" type="button" v-if="n >= 0">↻</button><button class="action-button" type="button" @click="get_card" v-if="n < 51">Get card</button>
      </div>
    </form>
  </div>
</template>
↻
<script>

import Random from './../utils/random'

const DEAL = '/audio/cards/deal.mp3';

export default {
  data: function () {
    return {
      'destination': 0,
      'current': 0,
      'deck': this.create_deck(),
      'n': -1,
    }
  },
  methods: {
    'reset': function () {
      this.$data.n = -1;
      this.$data.deck = this.create_deck();
    },
    'create_deck': function () {
      return Random.getShuffledArray(0, 52)
    },
    'get_card': function () {
      this.$data.n = this.$data.n + 1;
      (new Audio(DEAL)).play();
    }
  }
}
</script>

<style src="./../assets/css/game.css" scoped></style>
<style scoped>

  #cards-game {
    background: #d59a5c url('../assets/img/game/cards/bg.jpg');
  }

  #card {
    background: 50% 50% no-repeat;
    background-size: contain;
    width: 240px;
    height: 320px;
    z-index: 1;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -160px;
    margin-left: -120px;
  }

  @media all and (max-width: 919px) {

    #card {
      width: 180px;
      height: 240px;
      margin-top: -120px;
      margin-left: -90px;
    }

  }

  #card[data-card="0"] {
    background-image: url('../assets/img/game/cards/cards/A-clubs.png');
  }
  #card[data-card="1"] {
    background-image: url('../assets/img/game/cards/cards/2-clubs.png');
  }
  #card[data-card="2"] {
    background-image: url('../assets/img/game/cards/cards/3-clubs.png');
  }
  #card[data-card="3"] {
    background-image: url('../assets/img/game/cards/cards/4-clubs.png');
  }
  #card[data-card="4"] {
    background-image: url('../assets/img/game/cards/cards/5-clubs.png');
  }
  #card[data-card="5"] {
    background-image: url('../assets/img/game/cards/cards/6-clubs.png');
  }
  #card[data-card="6"] {
    background-image: url('../assets/img/game/cards/cards/7-clubs.png');
  }
  #card[data-card="7"] {
    background-image: url('../assets/img/game/cards/cards/8-clubs.png');
  }
  #card[data-card="8"] {
    background-image: url('../assets/img/game/cards/cards/9-clubs.png');
  }
  #card[data-card="9"] {
    background-image: url('../assets/img/game/cards/cards/10-clubs.png');
  }
  #card[data-card="10"] {
    background-image: url('../assets/img/game/cards/cards/J-clubs.png');
  }
  #card[data-card="11"] {
    background-image: url('../assets/img/game/cards/cards/Q-clubs.png');
  }
  #card[data-card="12"] {
    background-image: url('../assets/img/game/cards/cards/K-clubs.png');
  }


  #card[data-card="13"] {
    background-image: url('../assets/img/game/cards/cards/A-diamonds.png');
  }
  #card[data-card="14"] {
    background-image: url('../assets/img/game/cards/cards/2-diamonds.png');
  }
  #card[data-card="15"] {
    background-image: url('../assets/img/game/cards/cards/3-diamonds.png');
  }
  #card[data-card="16"] {
    background-image: url('../assets/img/game/cards/cards/4-diamonds.png');
  }
  #card[data-card="17"] {
    background-image: url('../assets/img/game/cards/cards/5-diamonds.png');
  }
  #card[data-card="18"] {
    background-image: url('../assets/img/game/cards/cards/6-diamonds.png');
  }
  #card[data-card="19"] {
    background-image: url('../assets/img/game/cards/cards/7-diamonds.png');
  }
  #card[data-card="20"] {
    background-image: url('../assets/img/game/cards/cards/8-diamonds.png');
  }
  #card[data-card="21"] {
    background-image: url('../assets/img/game/cards/cards/9-diamonds.png');
  }
  #card[data-card="22"] {
    background-image: url('../assets/img/game/cards/cards/10-diamonds.png');
  }
  #card[data-card="23"] {
    background-image: url('../assets/img/game/cards/cards/J-diamonds.png');
  }
  #card[data-card="24"] {
    background-image: url('../assets/img/game/cards/cards/Q-diamonds.png');
  }
  #card[data-card="25"] {
    background-image: url('../assets/img/game/cards/cards/K-diamonds.png');
  }


  #card[data-card="26"] {
    background-image: url('../assets/img/game/cards/cards/A-hearts.png');
  }
  #card[data-card="27"] {
    background-image: url('../assets/img/game/cards/cards/2-hearts.png');
  }
  #card[data-card="28"] {
    background-image: url('../assets/img/game/cards/cards/3-hearts.png');
  }
  #card[data-card="29"] {
    background-image: url('../assets/img/game/cards/cards/4-hearts.png');
  }
  #card[data-card="30"] {
    background-image: url('../assets/img/game/cards/cards/5-hearts.png');
  }
  #card[data-card="31"] {
    background-image: url('../assets/img/game/cards/cards/6-hearts.png');
  }
  #card[data-card="32"] {
    background-image: url('../assets/img/game/cards/cards/7-hearts.png');
  }
  #card[data-card="33"] {
    background-image: url('../assets/img/game/cards/cards/8-hearts.png');
  }
  #card[data-card="34"] {
    background-image: url('../assets/img/game/cards/cards/9-hearts.png');
  }
  #card[data-card="35"] {
    background-image: url('../assets/img/game/cards/cards/10-hearts.png');
  }
  #card[data-card="36"] {
    background-image: url('../assets/img/game/cards/cards/J-hearts.png');
  }
  #card[data-card="37"] {
    background-image: url('../assets/img/game/cards/cards/Q-hearts.png');
  }
  #card[data-card="38"] {
    background-image: url('../assets/img/game/cards/cards/K-hearts.png');
  }


  #card[data-card="39"] {
    background-image: url('../assets/img/game/cards/cards/A-spades.png');
  }
  #card[data-card="40"] {
    background-image: url('../assets/img/game/cards/cards/2-spades.png');
  }
  #card[data-card="41"] {
    background-image: url('../assets/img/game/cards/cards/3-spades.png');
  }
  #card[data-card="42"] {
    background-image: url('../assets/img/game/cards/cards/4-spades.png');
  }
  #card[data-card="43"] {
    background-image: url('../assets/img/game/cards/cards/5-spades.png');
  }
  #card[data-card="44"] {
    background-image: url('../assets/img/game/cards/cards/6-spades.png');
  }
  #card[data-card="45"] {
    background-image: url('../assets/img/game/cards/cards/7-spades.png');
  }
  #card[data-card="46"] {
    background-image: url('../assets/img/game/cards/cards/8-spades.png');
  }
  #card[data-card="47"] {
    background-image: url('../assets/img/game/cards/cards/9-spades.png');
  }
  #card[data-card="48"] {
    background-image: url('../assets/img/game/cards/cards/10-spades.png');
  }
  #card[data-card="49"] {
    background-image: url('../assets/img/game/cards/cards/J-spades.png');
  }
  #card[data-card="50"] {
    background-image: url('../assets/img/game/cards/cards/Q-spades.png');
  }
  #card[data-card="51"] {
    background-image: url('../assets/img/game/cards/cards/K-spades.png');
  }


</style>
